// src/components/screens/ProductScreen.jsx
import React, { useState } from 'react';
import { ArrowLeft, Heart, Star, ChevronRight } from 'lucide-react';
import recomendedProducts from '../../dados/recomendedProducts'
import ProductCard from '../common/ProductCard';
import { getProduct } from '../../store/useProduct';

const ProductScreen = ({setActiveScreen}) => {
    const [product, setProduct] = useState(getProduct());

    function handleProductClick(product) {
      setProduct(product)
    }

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Header */}
            <div className="bg-white p-4 flex items-center justify-between">
                <div className="flex items-center">
                    <ArrowLeft size={24} className="mr-2 cursor-pointer" onClick={() => setActiveScreen('home')} />
                    <h2 className="text-xl font-medium">Detalhes do Produto</h2>
                </div>
                <div className="flex items-center gap-4">
                    <Heart size={24} />
                </div>
            </div>

            {/* Product Image */}
            <div className="bg-white p-6 flex justify-center">
                <div className={`bg-${product.image} w-64 h-64 bg-gray-100 rounded-lg flex items-center justify-center`}>
                </div>
            </div>

            {/* Product Info */}
            <div className="bg-white p-4 shadow-sm mb-2">
                <div className="flex justify-between items-start mb-2">
                    <h1 className="text-xl font-bold text-gray-800">
                      {product.title}
                    </h1>
                    <div className="text-xl font-bold text-teal-800">{product.price}</div>
                </div>
                <div className="flex items-center mb-4">
                    <div className="flex items-center">
                        <Star size={16} fill="#FFD700" color="#FFD700" />
                        <span className="ml-1 text-gray-700">{product.rating}</span>
                    </div>
                </div>
                <p className="text-gray-600 mb-2">{product.description}</p>
            </div>

            {/* Product Description */}
            <div className="bg-white p-4 shadow-sm mb-2">
                <h3 className="font-semibold text-gray-800 mb-2">Descrição</h3>
                <p className="text-gray-600">
                    {product.longDescription}
                </p>  
            </div>

            {/* Recommendations */}
            <div className="mb-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Produtos Recomendados</h3>
                <button className="text-green-600 text-sm font-medium flex items-center" onClick={() => setActiveScreen('shop')}>
                  Ver todos
                  <ChevronRight size={16} />
                </button>
              </div>
              
              <div className="flex space-x-3 overflow-x-auto pb-2">
                {
                  recomendedProducts.map((product, index) => (
                    <ProductCard
                      key={index}
                      image={product.image} 
                      title={product.title} 
                      description={product.description} 
                      price={product.price} 
                      discount={product.discount} 
                      rating={product.rating} 
                      icon={product.icon}
                      onClick={() => handleProductClick(product)}
                    />
                  ))
                }
              </div>
            </div>

            {/* Bottom Action */}
            <div className="fixed bottom-0 left-0 right-0 bg-white p-4 shadow-lg flex gap-2">
                <button className="flex-1 bg-gray-200 text-teal-800 font-medium py-3 rounded-lg">
                    Adicionar à Lista
                </button>
                <button className="flex-1 bg-teal-700 text-white font-medium py-3 rounded-lg">
                    Comprar Agora
                </button>
            </div>
        </div>
    );
};

export default ProductScreen;